import React from 'react';

import { useIntl } from 'react-intl';

import { IconButton } from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import ChevronUpIcon from '@atlaskit/icon/core/chevron-up';
import PageIcon from '@atlaskit/icon/core/page';
import IconTile from '@atlaskit/icon/icon-tile';
import { Flex, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import messages from '../messages';

const styles = cssMap({
	container: {
		paddingTop: token('space.150'),
		paddingRight: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
	},
});

type CardHeaderProps = {
	ruleName: string;
	isOpen: boolean;
	onToggle: () => void;
};

export const CardHeader = ({ ruleName, isOpen, onToggle }: CardHeaderProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Flex justifyContent="space-between" xcss={styles.container}>
			<Flex alignItems="center" gap="space.100">
				<IconTile
					icon={PageIcon}
					label={formatMessage(messages.cardTitle)}
					appearance="orange"
					size="small"
				/>
				<Flex direction="column">
					<Text>{ruleName}</Text>
					<Text size="small" color="color.text.subtlest">
						{formatMessage(messages.cardTitle)}
					</Text>
				</Flex>
			</Flex>
			<Flex alignItems="center">
				<IconButton
					icon={isOpen ? ChevronUpIcon : ChevronDownIcon}
					label={formatMessage(isOpen ? messages.collapseCardLabel : messages.expandCardLabel)}
					appearance="subtle"
					spacing="compact"
					onClick={onToggle}
					testId="studio-automation-create-rule-card.toggle-button"
				/>
			</Flex>
		</Flex>
	);
};
